import { DealsApi, DealsListResponseDTO } from "@app/bf-api";
import { moduleMapperThrowMessage } from "@app/api/wp-page-fetcher/utils/module-mapper-error-handling";
import Logger from "@app/util/logger";

export const getDealsApi = async (
  take: number,
  skip: number,
  platformId: number,
  merchantId?: string,
  filters?: string,
  orderByDirection?: string,
  orderBy?: string,
  onlySponsored?: boolean,
  allLiveDeals?: boolean
): Promise<DealsListResponseDTO | undefined> => {
  try {
    const api = new DealsApi();
    const resultFromApi = await api.findAllDealsByFilters({
      skip,
      take,
      platformId,
      // A store page shows the store's sponsored deals as well, so all live deals means no sponsored filter.
      sponsored: onlySponsored ? 1 : allLiveDeals ? undefined : 0,
      filters,
      searchQuery: "",
      merchantFilters: merchantId,
      orderBy,
      orderByDirection,
      // Without it the API returns only the deals the deal overview shows: at most 3 per product (EAN).
      allLiveDeals: allLiveDeals || undefined
    });

    if (!resultFromApi || !resultFromApi.deals) return moduleMapperThrowMessage("Cannot get deals");

    return resultFromApi;
  } catch (e) {
    Logger.logError(e, "Error in: getDealsApi");

    return undefined;
  }
};
